import { callApi } from './callApi';

export default async ({ boxID, type = 'system', note }) => {
  return callApi({
    endpoint: `boxes/${boxID}/notes`,
    method: 'POST',
    body: {
      type,
      note,
    },
  });
};
